import { InitState } from '../reducers/root/initialState'

const hasText = (value: string | undefined): value is string => !!value && value.trim().length > 0

export const selectInsertionData = (state: InitState) => state.insertionFeature.insertionData

export const selectHasRequiredAddressForValuation = (state: InitState): boolean => {
  const { street, city, houseNumber } = selectInsertionData(state)
  return hasText(street) && hasText(city) && hasText(houseNumber)
}
